import { Injectable } from '@angular/core';
import { api } from '../properties/endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IntegrationStatusService {

  constructor(private http: HttpClient) { }

  getStatus() {
    const url = `${api.host}/ai-assistant/integration-status`;
    return this.http.get(url);
  }
}
